import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { useEditMode } from '@/contexts/EditModeContext';
import { DCA_LINKS } from '@/lib/dcaConfig';

const CTABanner = ({ 
  title = "The best investment you can make is in yourself. And you deserve a rewarding career!",
  buttonText = "Free 20-Minute Career Strategy Session",
  buttonLink = null,
  openScheduling = true,
  variant = "default",
  id = "default"
}) => {
  const { isEditMode, sendEditMessage } = useEditMode();
  const isExternal = buttonLink?.startsWith('http');

  const handleEditClick = (e) => {
    if (isEditMode) {
      e.preventDefault();
      e.stopPropagation();
      sendEditMessage('cta_banner', id, { id, title, buttonText, buttonLink, variant });
    }
  };

  const handleButtonClick = (e) => {
    if (isEditMode) {
      handleEditClick(e);
      return;
    }
    if (openScheduling && !buttonLink) {
      window.open(DCA_LINKS.free20, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section 
      className={`py-10 ${variant === 'alt' ? 'bg-secondary' : 'bg-primary'} relative ${isEditMode ? 'cursor-pointer group' : ''}`}
      onClick={handleEditClick}
    >
      {isEditMode && (
        <div className="absolute inset-0 border-2 border-dashed border-transparent group-hover:border-yellow-400 transition-all duration-200 pointer-events-none z-10">
          <div className="absolute -top-8 left-4 bg-yellow-400 text-black text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
            Edit CTA Banner
          </div>
        </div>
      )}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-white text-center md:text-left max-w-2xl">
            {title}
          </h2>
          
          {isExternal ? (
            <Button
              asChild
              variant="outline"
              size="lg"
              className="bg-white text-foreground hover:bg-white/90 border-white shrink-0"
              data-testid="cta-banner-btn"
            >
              <a href={isEditMode ? '#' : buttonLink} target={isEditMode ? undefined : "_blank"} rel="noopener noreferrer" onClick={isEditMode ? handleEditClick : undefined}>
                {buttonText} <ArrowRight className="w-4 h-4 ml-2" />
              </a>
            </Button>
          ) : buttonLink ? (
            <Button
              asChild
              variant="outline"
              size="lg"
              className="bg-white text-foreground hover:bg-white/90 border-white shrink-0"
              data-testid="cta-banner-btn"
            >
              <Link to={isEditMode ? '#' : buttonLink} onClick={isEditMode ? handleEditClick : undefined}>
                {buttonText} <ArrowRight className="w-4 h-4 ml-2" />
              </Link>
            </Button>
          ) : (
            <Button
              variant="outline"
              size="lg"
              className="bg-white text-foreground hover:bg-white/90 border-white shrink-0"
              data-testid="cta-banner-btn"
              onClick={handleButtonClick}
            >
              {buttonText} <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          )}
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
